export default "__VITE_PUBLIC_ASSET__e86b2632__"